import React from "react";

const NoAssetsComponent: React.FC = () =>
    <main className="asset-reliance-empty-container">
        <div className="header-font">No assets or goals have been captured yet.</div>
        <div className="body-font">Enter your assets and goals to Review Asset Reliance.</div>
    </main>;

export default NoAssetsComponent;